<template>
  <div>
    <Toggler
      :active-text="textYearly"
      :inactive-text="textMonthly"
      :active="isYearly"
      @input="toggleSubscription"
      field-name="subscription"
      column
    ></Toggler>
    <slot v-if="isYearly" name="yearly"></slot>
    <slot v-else name="monthly"></slot>
  </div>
</template>

<script>
import Toggler from "./Toggler";

export default {
  name: "PricingToggler",
  components: {
    Toggler,
  },
  props: {
    textYearly: {
      type: String,
      required: true,
    },
    textMonthly: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isYearly: true,
    };
  },
  methods: {
    toggleSubscription() {
      this.isYearly = !this.isYearly;
    },
  },
};
</script>
